import { render, staticRenderFns } from "./bindywy.vue?vue&type=template&id=dd433d04&scoped=true"
import script from "./bindywy.vue?vue&type=script&lang=js"
export * from "./bindywy.vue?vue&type=script&lang=js"
import style0 from "./bindywy.vue?vue&type=style&index=0&id=dd433d04&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd433d04",
  null
  
)

export default component.exports